module.exports = __webpack_public_path__ + "img/pr-8.b4aeb435.png";